import React, { useEffect, useState } from 'react';
import styles from './Crossfade.module.scss';

type CrossfadeProps = {
    content: React.ReactNode;
    identity: string | number;
    className?: string;
    duration?: number; // fade duration in ms
};

const CrossFade = ({ content, identity, className = '', duration = 300 }: CrossfadeProps) => {
    const [current, setCurrent] = useState<React.ReactNode>(content);
    const [fadeState, setFadeState] = useState<'visible' | 'hidden'>('visible');

    useEffect(() => {
        setFadeState('hidden');

        const timeout = setTimeout(() => {
            setCurrent(content);
            setFadeState('visible');
        }, duration);

        return () => clearTimeout(timeout);
    }, [identity, duration]);

    return (
        <div
            className={`${styles.crossfadeItem} ${styles[fadeState]} ${className}`}
            style={{ transitionDuration: `${duration}ms` }}>
            {current}
        </div>
    );
};

export default CrossFade;
